import React from "react";
type LogProps = React.PropsWithChildren<{}>;
function ChecklistUI(props: LogProps) {
	return <div className="h-full">{props.children}</div>;
}

export default ChecklistUI;
